import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { RestClientService } from '@common/services/rest-client/rest-client.service';

import { SettingsService } from '@common/services/settings/settings.service';
import { SessionStorageService } from '@common/services/storage/session-storage.service';

import { AppService } from '@common/services/app.service';

/**
 * Hide the APP loading SplashScreen
 */
function hideSplashScreen(): void {
    const splashScreen = document.querySelector('div.AppSplashScreen');
    if ( splashScreen ) {
        splashScreen.classList.remove('fade-in');
        splashScreen.classList.add('fade-out');
    }
}

export function appInitFactory(): () => Promise<any> {
    const requestedUrl = window.location.pathname.replace('#', '');

    return (): Promise<any> => {
        return new Promise( ( resolve ) => {

            resolve(true);
            hideSplashScreen();

            // const storage   = inject(SessionStorageService);
            // const settings  = inject(SettingsService);
            // const app       = inject(AppService);
            // const http      = inject(RestClientService);
            // const router    = inject(Router);
            // const roles     = settings.get('roles');

            // http.public().get('/catalog/categories').subscribe(
            //     (categories) => {
            //         app.setCategories(categories);

            //         http.public().get(`/catalog/category/${categories[0].id}`).subscribe(
            //             (products) => {
            //                 app.setProducts(products);

            //                 if ( http.isAuthorized() ) {
            //                     http.secured().validateToken().subscribe(
            //                         (payload) => {
            //                             if (payload.account) {
            //                                 storage.namespace('account' ).set( payload.account );

            //                                 const roleUri = roles[payload.account.role.ui_module]
            //                                     ? roles[payload.account.role.ui_module].rolesUri
            //                                     : '';

            //                                 if ( roleUri ) {
            //                                     router
            //                                         .navigate([ requestedUrl === '/' ? roleUri : requestedUrl ] )
            //                                         .then(() => { hideSplashScreen(); });
            //                                 } else {
            //                                     router.navigate(['/catalog']).then(() => { hideSplashScreen(); });
            //                                 }
            //                             } else {
            //                                 http.revoke();
            //                                 storage.namespace('account' ).set( null );
            //                                 router.navigate(['/catalog']).then(() => { hideSplashScreen(); });
            //                             }
            //                         },
            //                         () => {
            //                             http.revoke();
            //                             storage.namespace('account' ).set( null );
            //                             router.navigate(['/catalog']).then(() => { hideSplashScreen(); });
            //                         },
            //                         () => { resolve(null); }
            //                     );
            //                 } else {
            //                     resolve(null); hideSplashScreen();
            //                 }

            //             }
            //         );
            //     }
            // );

      });
    };
}